import React from 'react';

import { PickerView } from 'antd-mobile';

import { convertStyleData } from '@utils/tools';
import { appMethod as app } from '@utils/app';
import util from '@utils/util';

import './CitylocationCustomComponent.less';


export default class CitylocationCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let pageRequestNum = pageInstance.requestNum;
    let customFeature = pageInstance.data.eles[compindex].customFeature;
    let form = customFeature.citylocation ? customFeature.citylocation.customFeature.form : '';
    pageInstance.data.eles[compindex].citylocationHidden = false;

    let newdata = {};
    newdata['eles[' + compindex + '].value'] = ['', '', ''];
    if (app.globalData.locationInfo.latitude) {
      let info = app.globalData.locationInfo.info;

      newdata['eles[' + compindex + '].local'] = info.address_component.province + ' ' + info.address_component.city + ' ' + info.address_component.district + ' >';
      pageInstance.setData(newdata);
    } else {
      app.getLocation({
        success: function (res) {
          let latitude = res.latitude,
            longitude = res.longitude;
          if (!latitude) {
            newdata = {};
            newdata['eles[' + compindex + '].local'] = '定位失败';
            pageInstance.setData(newdata);
            return;
          }
          pageInstance.requestNum = pageRequestNum + 1;
          app.sendRequest({
            hideLoading: pageRequestNum++ == 1 ? false : true,
            url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
            data: {
              latitude: latitude,
              longitude: longitude
            },
            success: function (res) {
              newdata['eles[' + compindex + '].local'] = res.data.address_component.province + ' ' + res.data.address_component.city + ' ' + res.data.address_component.district + ' >';
              pageInstance.setData(newdata);

              app.setLocationInfo({
                latitude: latitude,
                longitude: longitude,
                address: res.data.formatted_addresses.recommend,
                info: res.data
              });
            }
          })
        }
      });
    }
    pageInstance.requestNum = pageRequestNum + 1;
    app.sendRequest({
      hideLoading: pageRequestNum++ == 1 ? false : true,   // 页面第一个请求才展示loading
      url: '/index.php?r=AppRegion/getAllExistedDataRegionList&is_xcx=1&form=' + form,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        let newArea = {};
        newArea['eles[' + compindex + '].areaList'] = res.data;
        pageInstance.setData(newArea);
      }
    });
  }

  selectLocal = (event) => {
    let compindex = event.currentTarget.dataset.compindex;
    let pageInstance = app.getAppCurrentPage();
    let compdata = pageInstance.data.eles[compindex];
    let newdata = {};
    newdata['eles[' + compindex + '].citylocationHidden'] = typeof (compdata.citylocationHidden) == undefined ? false : !compdata.citylocationHidden;
    if (!compdata.hasIntial){
      // areaList处理后的数据
      let afterAreaList = [
        {
          label: '请选择',
          value: '',
          children: [
            {
              label: '请选择',
              value: '',
              children: [
                {
                  label: '请选择',
                  value: ''
                }
              ]
            }
          ]
        }
      ];
      for (let province of compdata.areaList) {
        let afterProvice = {};
        afterProvice['label'] = province['name'];
        afterProvice['value'] = province['region_id'];
        afterProvice['children'] = [];
        for (let city of province.cities) {
          let afterCity = {};
          afterCity['label'] = city['name'];
          afterCity['value'] = city['region_id'];
          afterCity['children'] = [];
          for (let town of city.towns) {
            let afterTown = {};
            afterTown['label'] = town['name'];
            afterTown['value'] = town['region_id'];
            afterCity['children'].push(afterTown);
          }
          afterProvice['children'].push(afterCity);
        }
        afterAreaList.push(afterProvice);
      }
      newdata['eles[' + compindex + '].afterAreaList'] = afterAreaList;
      newdata['eles[' + compindex + '].hasIntial'] = true;
    }
    pageInstance.setData(newdata);
  }

  cancelCity = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex    = event.currentTarget.dataset.compindex;
    let compdata     = pageInstance.data.eles[compindex];
    pageInstance.setData({
      ['eles[' + compindex + '].citylocationHidden']: !compdata.citylocationHidden
    });
  }

  submitCity = (event) => {
    let compindex = event.currentTarget.dataset.compindex;
    let pageInstance = app.getAppCurrentPage();
    let compdata = pageInstance.data.eles[compindex];
    const { afterAreaList, value } = compdata;
    let newdata = {};
    if (!value || value.length < 3 || !value[2]) {
      app.showModal({ content: '您未选择城市!' });
    } else {
      newdata['eles[' + compindex + '].citylocationHidden'] = !compdata.citylocationHidden;
      let province = afterAreaList.find((item) => item.value === value[0]);
      let city = province['children'].find((item) => item.value === value[1]);
      let district = city['children'].find((item) => item.value === value[2]);
      newdata['eles[' + compindex + '].newlocal'] = province['label'] + city['label'] + district['label'];
      pageInstance.setData(newdata);
      let regionId = value[2];
      this._citylocationList(event.currentTarget.dataset, regionId);
    }
  }

  bindCityChange = (value) => {
    let compindex    = this.props.index;
    let pageInstance = app.getAppCurrentPage();
    pageInstance.setData({
      ['eles[' + compindex + '].value']: value
    });
  }

  _citylocationList = (dataset, region_id) => {
    let listid = dataset.listid;
    let listType = dataset.listtype;
    let form = dataset.form;
    let pageInstance = app.getAppCurrentPage();
    let newdata = {};
    let needColumnArr = [];

    let componentIndex = app.findComponentIndexById(listid);
    if (componentIndex === -1) {
      return;
    }
    let componentData = pageInstance.data.eles[componentIndex];
    // 拼团列表 单独处理
    if (listType == 'group-buy-list') {
      pageInstance.callComponentMethod({
        componentIndex: componentIndex,
        methodName: 'getGroupBuyList',
        argvs: [componentIndex, {
          param: {
            page: 1,
            status: componentData.selectNum,
            region_id: region_id
          }
        }]
      });
      return;
    }
    
    if (listType === 'list-vessel' || listType === 'dynamic-classify') {
      // 动态列表、动态分类
      newdata['eles[' + componentIndex + '].list_data'] = [];
      needColumnArr = componentData.need_column_arr || [];
    } else if (listType === 'goods-list') {
      // 商品列表
      newdata['eles[' + componentIndex + '].goods_data'] = [];
    } else if (listType === 'franchisee-list') {
      // 多商家列表
      newdata['eles[' + componentIndex + '].franchisee_data'] = [];
    }
    newdata['eles[' + componentIndex + '].param.page'] = 1;
    newdata['eles[' + componentIndex + '].loading'] = true;
    newdata['eles[' + componentIndex + '].loadingFail'] = false;
    newdata['eles[' + componentIndex + '].is_more'] = 1;
    pageInstance.setData(newdata);

    let url = '/index.php?r=AppData/GetFormDataList&idx_arr[idx]=region_id&idx_arr[idx_value]=' + region_id + '&extra_cond_arr[latitude]=' + app.globalData.locationInfo.latitude + '&extra_cond_arr[longitude]=' + app.globalData.locationInfo.longitude + '&extra_cond_arr[county_id]=' + region_id;
    let param = {
      form: form
    };
    if (needColumnArr.length) { // 优化请求
      param.need_column_arr = needColumnArr;
    }
    app.sendRequest({
      url: url,
      data: param,
      method: 'post',
      hideLoading: true,
      chain: listType === 'franchisee-list' ? true : '',
      success: function (res) {
        if (res.data.length == 0) {
          setTimeout(function () {
            app.showModal({
              content: '没有找到与所选区域的相关的内容'
            });
          }, 0)
        }
        if (res.status == 0) {
          let newdata = {};

          if (listType === "goods-list") {
            newdata['eles[' + componentIndex + '].goods_data'] = res.data;
          } else if (listType === 'list-vessel') {
            if (param.form !== 'form') {
              let listField = pageInstance.data.eles[componentIndex].listField;
              for (let j in res.data) {
                for (let k in res.data[j].form_data) {
                  if (k == 'category') {
                    continue;
                  }
                  if (/region/.test(k)) {
                    continue;
                  }
                  if (k == 'goods_model') {
                    res.data[j].form_data.virtual_price = app.formVirtualPrice(res.data[j].form_data);
                  }
                  if (k == 'distance') {
                    res.data[j].form_data[k] = util.formatDistance(res.data[j].form_data[k]);
                  }

                  let description = res.data[j].form_data[k];
                  if (listField.indexOf(k) < 0 && /<("[^"]*"|'[^']*'|[^'">])*>/.test(description)) { //没有绑定的字段的富文本置为空
                    res.data[j].form_data[k] = '';
                  } else if (app.needParseRichText(description)) {
                    res.data[j].form_data[k] = app.getWxParseResult(description);
                  }
                }
              }
            }
            newdata['eles[' + componentIndex + '].list_data'] = res.data;
          } else if (listType === 'franchisee-list') {
            for (let index in res.data) {
              let distance = res.data[index].distance;
              res.data[index].distance = util.formatDistance(distance);
            }
            newdata['eles[' + componentIndex + '].franchisee_data'] = res.data;
          } else if (listType === 'dynamic-classify') {
            newdata['eles[' + componentIndex + '].list_data'] = res.data;
          }

          newdata['eles[' + componentIndex + '].is_more'] = res.is_more;
          newdata['eles[' + componentIndex + '].curpage'] = 1;
          newdata['eles[' + componentIndex + '].loading'] = false;
          newdata['eles[' + componentIndex + '].loadingFail'] = false;

          pageInstance.setData(newdata);
        }
      },
      fail: function (res) {
        let newdata = {};
        newdata['eles[' + componentIndex + '].loadingFail'] = true;
        newdata['eles[' + componentIndex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    })
  }

  render() {
    /**
     * 传入数据
     */ 
    const data = this.props.data;                // 组件数据
    /**
     * 组件配置对象
     */  
    const customFeature = data.customFeature;
    /**
     * 样式数据处理
     */
    const styleObj = convertStyleData(data.style);
    styleObj['padding'] = 'unset';
    styleObj['lineHeight'] = styleObj['height'];
    /**
     *  组件内容处理
     */   
    let content = data.content;
    /**
     * 返回组件
     */ 
    return (
      <div className="custom-component citylocation" >
        <div
          className="citylocation-input"
          style={styleObj}
          onClick={this.selectLocal}
          data-compindex={this.props.index}
          >{data.content}: {data.newlocal || data.local || '未选择'}</div>
        {
          data.citylocationHidden && 
          <div className="citylocation-choose">
            <div className="picker-btn">
              <span onClick={this.cancelCity} data-compindex={this.props.index}>取消</span>
              <span onClick={this.submitCity}
                data-compindex={this.props.index}
                data-listid={customFeature.citylocation.customFeature.id}
                data-listtype={customFeature.citylocation.type}
                data-form={customFeature.citylocation.customFeature.form}>确定</span>
            </div>
            <div className="picker-view">
              <PickerView
                cols={3}
                data={data.afterAreaList}
                value={data.value || ['', '', '']}
                onChange={this.bindCityChange}
                cascade={true}
              />
            </div>
          </div>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/citylocation-custom-component/CitylocationCustomComponent.jsx